import {
    getNameDay,
    getTekDay,
    getTime,
    strToDate,
} from './../../application/global.function';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/application/config.service.';
import { RnumbService } from 'src/app/services/rnumb.service';
// import { RecDoctorService } from './../../../services/to-doctor/rec-doctor.service';
import { IRnumbList } from 'src/app/interfaces/rnumb.interfaces';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import type { ITalon } from './interfaces';
@Component({
    selector: 'app-block-talons',
    templateUrl: './block-talons.component.html',
    styleUrls: ['./block-talons.component.scss'],
    imports: [CommonModule]
})
export class BlockTalonsComponent implements OnInit {
    //  talons: Ihdoctor[] = [];
    public talons: IRnumbList[] = [];
    public talonsTime: ITalon[] = [];
    public loading: boolean = true;
    private _loadHistoryTalons = false;

    public constructor(
        private rs: RnumbService,
        private configS: ConfigService,
        private router: Router,
    ) {}

    public ngOnInit(): void {
        this.talons = [];
        this.talonsTime = [];
        this.rs.getRnumbList().subscribe((results) => {
            this.talons = results;
            this.talons.forEach((item) => {
                item.beginDate = strToDate(item.datBgn);
                item.endDate = strToDate(item.datEnd);
            });

            this._loadHistoryTalons = false;

            // Сортировка
            this.talons = this.talons.sort((a, b) => {
                if (!a.beginDate || !b.beginDate) {
                    return 0;
                }
                return a.beginDate.getTime() - b.beginDate.getTime();
            });
            this.convertFirstTwoTalonsToTalonsTime();
            this.loading = false;
        });
    }

    private convertFirstTwoTalonsToTalonsTime(): void {
        // Берем первые  две записи
        const firstTwoTalons = this.talons.slice(0, 2);

        this.talonsTime = firstTwoTalons.map((talon) => {
            if (!talon.beginDate) {
                return {
                    tekDay: '',
                    Weekday: '',
                    times: undefined,
                };
            }

            return {
                tekDay: this.getTekDay(talon.beginDate),
                Weekday: this.getNameDay(talon.beginDate),
                time: this.getTime(talon.beginDate),
                spec: talon.spec,
                rnumb_id: talon.rnumbId,
                // times: [
                //     {
                //         talon_id: talon.rnumb_id,
                //         type_r: talon.type_r,
                //     },
                // ],
            };
        });
    }
    public navigateToHistory(talon?: any) {
        if (talon && talon.rnumb_id) {
            // Navigate with query parameters
            this.router.navigate(['/home/history'], {
                queryParams: {
                    selectedAppointmentId: talon.rnumb_id,
                    tab: 0, // 0 for upcoming appointments
                },
            });
        } else {
            // Regular navigation
            this.router.navigate(['/home/history']);
        }
    }
    //TODO PIECE OF SHIT BELOW

    public getTime(dt: Date): string {
        return getTime(dt);
    }

    public getTekDay(dt: Date): string {
        return getTekDay(dt);
    }

    public getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    public goTalon(talon: ITalon) {
        // Find the corresponding talon in the original talons array to get the type_r and talon_id
        const originalTalon = this.talons.find(
            (t) =>
                t.spec === talon.spec &&
                t.beginDate &&
                this.getTime(t.beginDate) === talon.time,
        );

        if (originalTalon && originalTalon.typeR) {
            if (originalTalon.typeR == 'visit') {
                window.open(
                    `${this.configS.getValue(
                        'hostBackend',
                    )}/history/visit/pdf/${null}/${originalTalon.rnumbId}.pdf`,
                    '_blank',
                );
            } else {
                this.router.navigate(['/home/history']);
            }
        } else {
            this.router.navigate(['/home/history']);
        }
    }
}
